import { render, staticRenderFns } from "./StockAssemblyMovement.vue?vue&type=template&id=0bd12fe6&scoped=true&"
import script from "./StockAssemblyMovement.vue?vue&type=script&lang=ts&"
export * from "./StockAssemblyMovement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd12fe6",
  null
  
)

export default component.exports